<template>
  <b-collapse :open="true" position="is-bottom" aria-id="contentIdForA11y4">
    <template #trigger="props">
      <a
        class="is-size-7"
        aria-controls="contentIdForA11y4"
        :aria-expanded="props.open"
      >
        <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
        {{ !props.open ? "Show error details" : "Hide error details" }}
      </a>
    </template>

    <div class="message is-danger">
      <div class="message-body">

        <slot>
        <p class="is-size-6"><strong>Something went wrong.</strong></p>
        </slot>

        <div class="subtitle is-size-7 my-1">
          <li v-for="(error, index) in errors" :key="index">
            {{ error.title }}
          </li>
        </div>

        <p v-if="error_id" class="is-size-7">
          TripCircuit error id:
          <span class="has-text-weight-semibold">{{ error_id }}</span>
        </p>

        <div class="is-size-7 mt-2" v-if="reportable && error_id">
          <b-button
            type="is-primary"
            size="is-small"
            @click="reportErrorToAdmin(error_id)"
            :disabled="disabled"
            v-if="!errorReported"
          >
            <div class="is-flex is-align-content-center">
              <span>Report Error to Admin</span>
              <span v-if="loading"
                ><ReloadIcon style="width: 16px;" class="ml-2"
              /></span>
            </div>
          </b-button>
          <p v-else class="is-size-6">
            Thank you for reporting the error!
          </p>
        </div>
      </div>
    </div>
  </b-collapse>
</template>

<script>
import bookingMixin from "@/mixins/bookingMixin";
import ReloadIcon from "/public/images/SVGs/Reload-1s-200px.svg";

export default {
  name: "SearchErrorMessage",
  components: {
    ReloadIcon,
  },
  mixins: [bookingMixin],
  props: {
    error_id: String,
    errors: Array,
    reportable: {
      type: Boolean,
      default: false
    },
  },
  data: function() {
    return {
      loading: false,
      disabled: false,
      errorReported: false,
    };
  },
  methods: {
    reportErrorToAdmin(error_id) {
      this.loading = true;
      this.disabled = true;

      //call  Huddle Labs' report error action
      this.$app
        .huddleLabsServerCall("actions/report-error", error_id)
        .then((result) => {
          // console.log('report error: ', result);
          this.loading = false;
          this.disabled = false;
          this.errorReported = true;
        });
    },
  },
  mounted() {
    // console.log(this.$props);
  },
};
</script>

<style scoped></style>
